import React from 'react';

import { token } from '@atlaskit/tokens';
import { css } from '@compiled/react';

const iconSizeStyles = css({
	height: '16px',
	width: '16px',
});

export const MyTemplatesStarIcon = (): React.JSX.Element => {
	return (
		<svg css={iconSizeStyles} viewBox="0 0 24 24">
			<path
				d="M 18.1914 23.085 C 17.922 23.085 17.6539 23.0022 17.4234 22.8377 L 12 18.9483 L 6.5767 22.8377 C 6.1147 23.1683 5.4947 23.1683 5.0353 22.8323 C 4.576 22.4995 4.3827 21.909 4.5547 21.3696 L 6.5773 14.8416 L 1.2027 11.0543 C 0.746 10.7176 0.556 10.1256 0.7307 9.5856 C 0.9067 9.0469 1.408 8.6809 1.9747 8.6769 L 8.6313 8.6669 L 10.7507 2.3009 C 10.9293 1.7616 11.4327 1.3989 12 1.3989 C 12.5673 1.3989 13.0707 1.7623 13.25 2.3009 L 15.3333 8.6669 L 22.0241 8.6769 C 22.5927 8.6809 23.0946 9.0476 23.2686 9.5856 C 23.444 10.1256 23.254 10.7176 22.7967 11.0543 L 17.422 14.8416 L 19.4447 21.3696 C 19.6181 21.909 19.4226 22.4995 18.9646 22.8323 C 18.7333 23.0016 18.4626 23.085 18.1914 23.085 Z"
				fill={token('color.background.accent.orange.subtle')}
			/>
		</svg>
	);
};
